<template>
  <div>
    <div>
      <el-button class="printBtn" type="primary" style="margin: 2mm 0 0 2mm" @click="printHandle">打印</el-button>
    </div>
    <div id="print">
      <div v-for="(item, index) in params.data" :key="index" class="printItem">
        <table cellpadding="0" cellspacing="0" style="height: 100%">
          <tr>
            <td rowspan="4">
              <div :id="'qrCode' + item.itemSn" align="center"/>
            </td>
            <td colspan="3" style="font-weight: 700; font-size: 12px">安徽火山湖智能装备有限公司产品标识卡</td>
          </tr>
          <tr>
            <td colspan="3">工单编号：{{params.orderInfo.productionOrderNo}}</td>
          </tr>
          <tr>
            <td colspan="3">派工单号：{{params.orderInfo.billNo}}</td>
          </tr>
          <tr>
            <td colspan="3">序列号：{{item.itemSn}}</td>
          </tr>
          <tr>
            <td>数量：{{params.orderInfo.quantity}}</td>
            <td>单位：{{params.orderInfo.unitName}}</td>
            <td colspan="2">物料号：{{params.orderInfo.materialNo}}</td>
          </tr>
          <tr>
            <td colspan="4">物料名称：{{params.orderInfo.materialName}}</td>
          </tr>
          <tr>
            <td colspan="4">规格：{{params.orderInfo.specification}}</td>
          </tr>
          <tr>
            <td colspan="4">工艺路线：{{params.orderInfo.routingName}}</td>
          </tr>
          <tr>
            <td colspan="4">
              状态：
              <el-checkbox>合格</el-checkbox>
              <el-checkbox>不合格</el-checkbox>
              <el-checkbox>已检验待判定</el-checkbox>
              <el-checkbox>未检验</el-checkbox>
            </td>
          </tr>
          <tr>
            <td colspan="2">作业员：</td>
            <td colspan="2">QC：</td>
          </tr>
          <tr>
            <td colspan="2">开工时间：{{params.orderInfo.planStartTime}}</td>
            <td colspan="2">完工时间：{{params.orderInfo.planFinishTime}}</td>
          </tr>
          <tr>
            <td colspan="2">销售单号：{{params.orderInfo.salesOrderNo}}</td>
            <td colspan="2">ERP单号：{{params.orderInfo.erpSalesOrderNo}}</td>
          </tr>
          <tr>
            <td colspan="4">合同号：{{params.orderInfo.customerContractNo}}</td>
          </tr>
          <tr>
            <td colspan="4">项目名称：{{params.orderInfo.projectName}}</td>
          </tr>
          <tr>
            <td colspan="4">客户名称：{{params.orderInfo.customerName}}</td>
          </tr>
          <tr>
            <td colspan="2">检验日期：</td>
            <td colspan="2">生产日期：{{item.prodTime ? item.prodTime.substring(0, 10) : ""}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        params: {
          orderInfo: {},
          data: [],
        },
      };
    },

    mounted() {
      this.params = Object.assign(this.params, JSON.parse(this.$route.query.params));
      for (let item of this.params.data) {
        this.$nextTick(() => {
          document.getElementById("qrCode" + item.itemSn).innerHTML = "";
          this.bindQRCode(item.itemSn);
        });
      }
    },

    methods: {
      bindQRCode(code) {
        new QRCode(document.getElementById("qrCode" + code), {
          text: code,
          width: 90,
          height: 90,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      printHandle() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        window.location.reload();
      },
    },
  };
</script>

<style lang="scss" scoped>
.printItem {
  width: 96mm;
  height: 146mm;
  border: 0.5mm solid #111;
  page-break-after: always;
  margin-top: 1.5mm;
  margin-left: 2mm;
  display: inline-block;
  font-size: 10px;
  table {
    width: 100%;
    tr {
      td {
        border-bottom: 0.5mm solid #111;
        border-right: 0.5mm solid #111;
        padding: 0 0.5mm;
        &:last-child {
          border-right: none;
        }
      }
      &:last-child td {
        border-bottom: none;
      }
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.el-checkbox {
  margin-right: 5px;
  .el-checkbox__label {
    padding-left: 5px !important;
    font-size: 10px !important;
  }
  .el-checkbox__input {
    .el-checkbox__inner {
      border: 0.5mm solid #111 !important;
    }
  }
}
</style>
